// extracted by mini-css-extract-plugin
export default {"output":"output_output__72tTu","outputTitle":"output_outputTitle__kMQ7C","outputHint":"output_outputHint__vqYvP","exercises":"output_exercises__GQbxg"};